import { useEffect, useState } from 'react'
import { onLCP } from 'web-vitals'

export const useLcpRecorded = (): boolean => {
    const [lcpRecorded, setLcpRecorded] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            setLcpRecorded(true)
        }

        onLCP(() => {
            setLcpRecorded(true)
        })

        window.addEventListener('scroll', handleScroll, { once: true })

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return lcpRecorded
}
